// extracted by mini-css-extract-plugin
module.exports = {"itemsContainer":"SelectBox_itemsContainer__IblDk"};